import { generateI18n } from "react-better-html";

import en from "../i18n/en.json";
import bg from "../i18n/bg.json";

export const i18n = generateI18n({
   defaultLanguage: "en",
   languages: {
      en: {
         code: "en",
         flagCode: "gb",
         name: "English",
         words: en,
      },
      bg: {
         code: "bg",
         flagCode: "bg",
         name: "Български",
         words: bg,
      },
   },
});

export const { useI18n } = i18n;
